import { gql } from "graphql-tag";
import { ApolloClient } from "@apollo/client/core";
import { UserBookSerializersUserBookDate } from "types/serializers";

// INSERT
const insertUserBookReadMutation = gql`
  mutation InsertUserBookReadMutation(
    $userBookId: Int!
    $userBookRead: DatesReadInput!
  ) {
    insertResult: insert_user_book_read(
      user_book_id: $userBookId
      user_book_read: $userBookRead
    ) {
      error
      userBookRead: user_book_read {
        ...UserBookReadFragment
        user_book {
          ...UserBookFragment
        }
      }
    }
  }
`;
export async function insertUserBookRead({
  client,
  userBookId,
  userBookRead,
}: {
  client: ApolloClient<any>;
  userBookId: number;
  userBookRead?: UserBookSerializersUserBookDate;
}): Promise<UserBookSerializersUserBookDate> {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: insertUserBookReadMutation,
        variables: {
          userBookId,
          userBookRead: {
            started_at: userBookRead?.startedAt,
            finished_at: userBookRead?.finishedAt,
            edition_id: userBookRead?.editionId,
            progress_pages: userBookRead?.progressPages,
            progress_seconds: userBookRead?.progressSeconds,
          },
        },
      })
      .then((result) => {
        if (result.data.insertResult.error) {
          reject(result.data.insertResult.error);
        } else {
          resolve(result.data.insertResult.userBookRead);
        }
      })
      .catch((e) => {
        reject(e.message);
      });
  });
}
